import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'mh-areas-images',
    templateUrl: './areas-images.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AreasImagesComponent {

}
